import React from 'react';

const TypingIndicator = ({ className = '' }) => (
  <div className={`waiter ${className}`.trim()}>
    <div className="dot" />
    <div className="dot" />
    <div className="dot" />
  </div>
);

TypingIndicator.displayName = 'TypingIndicator';

export default TypingIndicator;
